var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDanish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 19,
    viewBox: "0 0 28 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.903 18.3448H2.09699C0.93882 18.3448 0 17.406 0 16.2478V2.09699C0 0.938875 0.93882 0 2.09699 0H25.903C27.0611 0 28 0.938821 28 2.09699V16.2479C28 17.406 27.0612 18.3448 25.903 18.3448Z",
    fill: "#FF4B55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 7.72412H11.5862V0H8.68968V7.72412H0V10.6207H8.68968V18.3448H11.5862V10.6207H28V7.72412Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanish);
export default __webpack_public_path__ + "static/media/danish.10b8691c.svg";
export { ForwardRef as ReactComponent };